const Alerts = {
  ALERT_READ: 'alerts/read',
  ALERT_DONE: 'alerts/done',
}

export default Alerts;
